import {notify} from '../notify';
import {subscribe} from '../subscribe';
import {unsubscribe} from '../unsubscribe';

export function createPublisher(): Publisher {
  let subscribers: Subscriber[] = [];

  return {
    subscribe(subscriber: Subscriber) {
      subscribers = subscribe(subscriber, subscribers);
    },
    unsubscribe(subscriber: Subscriber) {
      subscribers = unsubscribe(subscriber, subscribers);
    },
    notify(message: Message) {
      notify(message, subscribers);
    },
  };
}
